











































































































































































































































	import { Vue,Component,Watch } from 'vue-property-decorator'
	import { State,Action,namespace } from 'vuex-class'
	import moment from 'moment'
	import icon from '../../assets/js/expressicon'
    const home = namespace('home')
	@Component
	export default class Monitoring extends Vue {
		site_org:string = '' //选取的网点ID
		icon:any = icon
		@home.State('loading') loading:any
		@home.State('siteDashboard') siteDashboard:any
		get search(){
			let start = '';
			let end = '';
			if(this.daterange){
				start = this.timestampToTime(this.daterange[0]) ;
				end = this.timestampToTime(this.daterange[1]);
			}
			return {
				site: this.site_org,
				start: start,
				end: end
			}
		}
		get deliverySearch(){
			let start = '';
			let end = '';
			if(this.daterange){
				start = this.timestampToTime(this.deliveryTime[0]) ;
				end = this.timestampToTime(this.deliveryTime[1]);
			}
			return {
				site: this.site_org,
				start: start,
				end: end
			}
		}
		radio2:number =  6
		deliveryRadio:number = 6
		daterange = [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date()]
		deliveryTime = [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date()]
		assignData = null //派件数据
		deliveryData = null //寄件数据
		chartData = null
		@home.State('chartList') chartList:any
		@home.Action('getAssignData') getAssignData:any
		@home.Action('getDeliveryData') getDeliveryData:any
		@home.Action('getVeLineData') getVeLineData:any
		@home.Action('getSiteGeneral') getSiteGeneral:any
		// 转换为时间格式提交给后台
		timestampToTime(timestamp:any) {
			var date = new Date(timestamp);
			var Y = date.getFullYear() + '-';
			var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
			var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + '';
			return Y+M+D;
		}
		//获得派件数据
		async getAssign(){
			const res = await this.getAssignData(this.search)
			const data = await this.getVeLineData(this.search)
			if(res){
				this.assignData = res
				this.chartData = data
			}
			console.log(res);
		}
		//获得寄件数据
		async getDelivery(){
			const res = await this.getDeliveryData(this.deliverySearch)
			if(res){
				this.deliveryData = res
			}
		}
		// 网点改变的时候
        async changeSite(val:string){
			this.site_org = val;
			this.getAssign()
			this.getDelivery()
			this.getSiteGeneral({
				site: val
			})
		}
		daterangechange(val:any){
            const end = new Date();
            const start = new Date();
            const daterange:any = [start, end]
            if (val == 6) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            }
            if (val == 9) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            }
            if (val == 12) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            }
            this.daterange = daterange
		}
		deliveryTimeChange(val:any){
            const end = new Date();
            const start = new Date();
            const daterange:any = [start, end]
            if (val == 6) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            }
            if (val == 9) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            }
            if (val == 12) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            }
            this.deliveryTime = daterange
		}
		@Watch('daterange')
		assignDaterange(val:string,old:string){
			this.getAssign()
		}
		@Watch('deliveryTime')
		deliveryTimeRange(val:string,old:string){
			this.getDelivery()
		}
	} 
